<template>
    <div>
        <div class="filter-heading cf">
            <p class="filter-title">
                Categories <!-- Categories <small v-if="selected.length">({{ selected.length }} applied)</small> -->
            </p>
        </div>
        <div class="filter-body">
            <!-- <div class="checkbox" v-for="item in getLevel(1)" :key="item.key">
                <label>
                    <input type="checkbox" v-model="selected" :value="item.key" @change="bump(1)">
                    <span class="faux-label">
                        <span v-html="item.key ? item.key : '-'"></span>
                        <span class="product-count">({{ item.count }})</span>
                    </span>
                </label>
            </div> -->
            <div :class="{'level' : n != 1 }" v-for="n in length" :key="n" v-if="shouldShow(n)">
                <div class="checkbox">
                    <label>
                        <input type="radio" :name="'CategoryPath_' + n" v-model="selected['CategoryPath_' + n]" :value="null" @change="bump(n)">
                        <span class="faux-label">All</span>
                    </label>
                </div>
                <div class="checkbox" v-for="item in getLevel(n)" :key="item.key">
                    <label>
                        <input type="radio" :name="'CategoryPath_' + n" v-model="selected['CategoryPath_' + n]" :value="item.key" @change="bump(n)">
                        <span class="faux-label">
                            <span v-html="item.key ? item.key : '-'"></span>
                            <span class="product-count">({{ item.count }})</span>
                        </span>
                    </label>

                </div>
            </div>
        </div>
        <!-- <div class="filter-footer">
            <button @click="expanded = false" v-if="expanded">Show less</button>
            <button @click="expanded = true" v-else-if="hiddenCount">Show {{ hiddenCount }} more </button>
        </div> -->
    </div>
</template>

<script>
    import { LoopCategoryFilter } from '../../../../Services/Search/LoopCategoryFilter.js';
    import Search from '../../../../Services/Search.js';
    import UrlHelpers from '../../../../Services/UrlHelpers.js';

    export default {
        props: {
            handle: {
                type: String,
                required: true,
            },
            categories: {
                type: Array|Object,
                default() {
                    return [];
                },
            },
        },
        data() {
            return {
                currentLevel: 1,
                selected: {},
                search: Search,
            }
        },
        mounted() {
            this.$nextTick(() => {
                _.each(this.categories, (cat , index) => {
                    this.$set(this.selected, index, UrlHelpers.getParam(index));
                });
                this.loaded();
            });
        },
        computed: {
            length() {
                return this.categories ? Object.keys(this.categories).length : 0; // Remove top
            }
        },
        methods: {
            shouldShow(n) {
                if (n == 1 || n < this.currentLevel) {
                    return true;
                }
                return this.currentLevel >= n && !this.search.resolving;
            },
            getLevel(level) {
                return this.categories['CategoryPath_' + level];
            },
            bump(current) {
                let level = 1,
                    offset = 1;
                const keys = Object.keys(this.selected);
                for (let index = current; index < keys.length; index++) {
                    // const element = array[index];
                    let key = keys[index];
                    this.selected[key] = null;
                }
                _.each(this.selected, item => {
                    if (item) {
                        level++;
                    }
                });

                this.$emit('bump', new LoopCategoryFilter(this.selected));
                this.currentLevel = level;
            },
            loaded() {
                let level = 1;
                _.each(this.selected, item => {
                    if (item) {
                        level++;
                    }
                });
                this.currentLevel = level;
                this.$emit('loaded', new LoopCategoryFilter(this.selected));
            }
        },
    }
</script>

<style lang="scss" scoped>
    .level {
        border-top:4px solid #eee;
        margin-top:.5em;
        padding-top:.5em;
        padding-bottom:.5em;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/Filters/Loop54/Categories.vue